export default "__VITE_ASSET__CsXEO7qy__"